<template>
    <div class="wechat-kefu">
        <div class="header">
            <div class="left">
                <label>为员工设置客服身份，设置后员工可在凤栖云服app与公众号粉丝进行主动营销</label>
            </div>
        </div>
        <div class="search-panel">
            <label>员工姓名</label>
            <el-input placeholder="请输入员工姓名" v-model="name" @keyup.enter.native="pageChange(1)"></el-input>
            <label>联系方式</label>
            <el-input placeholder="请输入联系方式" v-model="mobile" @keyup.enter.native="pageChange(1)"></el-input>
            <el-button type="warning" @click="pageChange(1)">查询</el-button>
        </div>
        <div class="body">
            <div class="page-title">客服列表</div>
            <el-table :data="tableData" border class="omtable" style="width: 100%">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="name" label="员工姓名"></el-table-column>
                <el-table-column prop="mobile" label="员工电话"></el-table-column>
                <el-table-column prop="createTime" label="入驻时间"></el-table-column>
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enable" active-text="" inactive-text="" @change="switchUpdate(scope.row)"></el-switch>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="page"  background layout="total,prev, pager, next" @current-change="pageChange" :page-size='10' :total="listCount">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import commom from "../../api/common";
import {ruleTool} from '@/api/mixins'
//当前实例组件
export default {
    mixins: [ruleTool],
    data: () => ({
        mechanId:"",
        name:"",//公众号名称
        mobile:"",//消息类型
        listCount:0,
        tableData:[],
        pageNum:1,
    }),
    components: {},
    mounted() {
        this.mechanId = this.$tools.getLocal("userinfo").mechanId
        this.getList();
    },
    methods: {
        switchUpdate(item) {
            // item.enable = !item.enable;
            this.$http({
                url:'/wechatthirdplat/kefuSubscriptionQuantity',
                type:'post',
                params: item,
            }).then((data)=> {
                this.$message.success('操作成功');
            })
        },
        pageChange(page){
            this.pageNum = page;
            this.getList();
        },
        getList(){
            const params = {
                mechanId:this.mechanId,
                name:this.name,
                mobile:this.mobile,
                pageSize:10,
                pageNum:this.pageNum
            }
            this.$http({
                url:'/wechatthirdplat/kefuSubscriptionQuantity/queryAllKefuByMechanId',
                type:'put',
                params: params,
            }).then((data)=> {
                this.tableData = data.data;
                this.listCount = data.total;
            })
        }
    },
};
</script>
<style lang="scss">
@import "./kefu";
</style>
